import Vue from "vue";
import App from "./App.vue";
// import store from "./store";
import router from './router'
import "./filters"
import './registerServiceWorker'

//const STORE_KEY = "skorit-data";

Vue.config.productionTip = false;

new Vue({
  /*
  store,

  beforeCreate() {
    this.$store.commit("initialiseStore");
  },
  */

  mounted() {
    /*
    this.$store.subscribe((mutation, state) => {
      // Store the state object as a JSON string
      localStorage.setItem(STORE_KEY, JSON.stringify(state));
    });*/
  },

  router,
  render: h => h(App)
}).$mount("#app");
